import React, { Component } from 'react';
import { connect } from 'react-redux';
import { populate, isLoaded, isEmpty } from 'react-redux-firebase';
// import { Link } from 'react-router';
// import Modal from 'react-modal';

import PanelList from '../../components/layout/panel-list';
import PanelListItemDuo from '../../components/layout/panel-list-item-duo';
// import ContactsModalRequests from './modal-requests';
// import { modalStyle } from '../../components/layout/modal/modal-style';

// const populateAuthor = [{ child: 'fromID', root: 'users' }];
const populates = [
  { root: 'users-info', child: 'contacts' },
  // { root: 'collaborations', child: 'collaborations' },
];
/* eslint-disable */

@connect(
  ({ firebase }) => ({
    account: populate(firebase, 'profile', populates) // populate settings are
  })
)
export default class Users extends Component {

  constructor(props) {
    super(props)
    this.state = {
      listLoading: true,

      filteredContacs: [],

      modalIsOpen: false,
    }

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }
  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  renderContacts() {
    const contacts = this.props.account.contacts
    return Object.keys(contacts).map((contact) => {
      return (<PanelListItemDuo
            key={ contact }
            url={ '/contacts/' + contact }
            title={ contacts[contact].displayName }
            info={ contacts[contact].email } />);
    });
  }

  render() {
    var list;
    if (!isLoaded(this.props.account)) {
      list = ( 'Loading' );
    } else if (isEmpty(this.props.account.contacts)) {
      list = ( 'Empty' );
    } else {
      list = this.renderContacts();
    }

    return (
      <main className="split">
        <aside>
          <PanelList
            title="Users"
            color="turquoise"
            actionRight={ this.openModal }
          >
            { list }
          </PanelList>
        </aside>
        { this.props.children }
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/users/index.jsx